export default __webpack_public_path__ + "static/media/Webhooks.787d98e1.svg";